export * from './lib/svgloader/svg-loader.module';
export * from './lib/svgloader/svg-loader.service';
export * from './lib/svgloader/svgIconAssets';
export * from './lib/window.service/window.service';
export * from './lib/memoized.operator';
